import * as React from "react"
import * as footer from "./footer.module.css"
import { Link } from "gatsby"
import { Facebook, Linkedin, Twitter, Youtube } from "react-feather"
import { StaticImage } from "gatsby-plugin-image"
import logo from '../images/logo-black.png'

const Footer = () => (
  <footer className={footer.base}>
    <div className={`content`}>
      <div className={footer.wrapper}>
        <div className={footer.socials}>
          <div className={footer.logo}>
            <StaticImage
              src="../images/logo-black.png"
              loading="eager"
              height={48}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="SIGCHI Logo"
            />
          </div>
          <Link to={`https://www.youtube.com/user/acmsigchi`} target="_blank">
            <div className={footer.social}>
              <Youtube />
            </div>
          </Link>
          <Link to={`https://twitter.com/sigchi`} target="_blank">
            <div className={footer.social}>
              <Twitter />
            </div>
          </Link>
          <Link
            to={`https://www.facebook.com/groups/17585169432`}
            target="_blank"
          >
            <div className={footer.social}>
              <Facebook />
            </div>
          </Link>
          <Link
            to={`https://www.linkedin.com/company/acm-sigchi/`}
            target="_blank"
          >
            <div className={footer.social}>
              <Linkedin />
            </div>
          </Link>
        </div>
        <div className={footer.links}>
          <Link to={`/`}>
            <div className={footer.link}>Home</div>
          </Link>
          <Link to={`/about`}>
            <div className={footer.link}>About</div>
          </Link>
          <Link to={`/community/chapters`}>
            <div className={footer.link}>Chapters</div>
          </Link>
          <Link to={`/conferences/calendar`}>
            <div className={footer.link}>Calendar</div>
          </Link>
          <Link to={`/news/announcements`}>
            <div className={footer.link}>Updates</div>
          </Link>
        </div>
        <div className={footer.links}>
          <Link to={`https://programs.sigchi.org/`}>
            <div className={footer.link}>SIGCHI Programs App</div>
          </Link>
          <Link to={`https://dl.acm.org/sig/sigchi`}>
            <div className={footer.link}>SIGCHI on ACM Digital Library</div>
          </Link>
          <Link to={`https://sigchi.submittable.com`}>
            <div className={footer.link}>Application Forms</div>
          </Link>
          <Link to={`/community/membership`}>
            <div className={footer.link}>Memberships</div>
          </Link>
          <Link to={`/contact`}>
            <div className={footer.link}>Contact Us</div>
          </Link>
        </div>
      </div>
    </div>
    <div className={footer.footNote}>
      <div>
        <p>
          © ACM Special Interest Group on Computer-Human Interaction &middot;{" "}
          {new Date().getFullYear()}
        </p>
        <p className={`vertically-align`}>
          Powered by
          <a
            href={`https://www.contentful.com/`}
            rel={`nofollow`}
            target={`_blank`}
            class={`no-style`}
          >
            <img
              src={`https://images.ctfassets.net/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg`}
              style={{ maxWidth: "100px", width: "100%", marginLeft: '0.4rem' }}
              alt={`Powered by Contentful`}
            />
          </a>
        </p>
      </div>
      <div>
        <Link to={`/`}>
          <p>Privacy Policy</p>
        </Link>
      </div>
      <div
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" })
        }}
        className={footer.backToTop}
      >
        <p>Back to top</p>
      </div>
    </div>
  </footer>
)

export default Footer
